// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/sidebar/sidebar_data.proto (package qliq_protobuf.sidebar, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message qliq_protobuf.sidebar.SidebarData
 */
export class SidebarData extends Message<SidebarData> {
  /**
   * @generated from field: repeated qliq_protobuf.sidebar.SidebarData.SidebarItem sidebar_items = 1;
   */
  sidebarItems: SidebarData_SidebarItem[] = [];

  /**
   * @generated from field: qliq_protobuf.sidebar.SidebarData.BrandingSettings branding_settings = 2;
   */
  brandingSettings?: SidebarData_BrandingSettings;

  /**
   * @generated from field: qliq_protobuf.sidebar.SidebarData.User user = 3;
   */
  user?: SidebarData_User;

  constructor(data?: PartialMessage<SidebarData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.sidebar.SidebarData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sidebar_items", kind: "message", T: SidebarData_SidebarItem, repeated: true },
    { no: 2, name: "branding_settings", kind: "message", T: SidebarData_BrandingSettings },
    { no: 3, name: "user", kind: "message", T: SidebarData_User },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SidebarData {
    return new SidebarData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SidebarData {
    return new SidebarData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SidebarData {
    return new SidebarData().fromJsonString(jsonString, options);
  }

  static equals(a: SidebarData | PlainMessage<SidebarData> | undefined, b: SidebarData | PlainMessage<SidebarData> | undefined): boolean {
    return proto3.util.equals(SidebarData, a, b);
  }
}

/**
 * @generated from enum qliq_protobuf.sidebar.SidebarData.Module
 */
export enum SidebarData_Module {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: GROUP_SETTINGS = 1;
   */
  GROUP_SETTINGS = 1,

  /**
   * @generated from enum value: ONCALL = 2;
   */
  ONCALL = 2,

  /**
   * @generated from enum value: VISIT_PATH = 3;
   */
  VISIT_PATH = 3,

  /**
   * @generated from enum value: VIRTUAL_CONVERSATIONS = 4;
   */
  VIRTUAL_CONVERSATIONS = 4,

  /**
   * @generated from enum value: BOT_DESIGNER = 5;
   */
  BOT_DESIGNER = 5,

  /**
   * @generated from enum value: CHAT_WIDGETS = 6;
   */
  CHAT_WIDGETS = 6,

  /**
   * @generated from enum value: FAQS = 7;
   */
  FAQS = 7,

  /**
   * @generated from enum value: QUICK_SIGNS = 8;
   */
  QUICK_SIGNS = 8,

  /**
   * @generated from enum value: QUICK_FORMS = 9;
   */
  QUICK_FORMS = 9,

  /**
   * @generated from enum value: CARE_CAMPAIGNS = 10;
   */
  CARE_CAMPAIGNS = 10,

  /**
   * @generated from enum value: SELF_SCHEDULES = 11;
   */
  SELF_SCHEDULES = 11,

  /**
   * @generated from enum value: REPORTS = 12;
   */
  REPORTS = 12,

  /**
   * @generated from enum value: GPT_STORE = 13;
   */
  GPT_STORE = 13,
}
// Retrieve enum metadata with: proto3.getEnumType(SidebarData_Module)
proto3.util.setEnumType(SidebarData_Module, "qliq_protobuf.sidebar.SidebarData.Module", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "GROUP_SETTINGS" },
  { no: 2, name: "ONCALL" },
  { no: 3, name: "VISIT_PATH" },
  { no: 4, name: "VIRTUAL_CONVERSATIONS" },
  { no: 5, name: "BOT_DESIGNER" },
  { no: 6, name: "CHAT_WIDGETS" },
  { no: 7, name: "FAQS" },
  { no: 8, name: "QUICK_SIGNS" },
  { no: 9, name: "QUICK_FORMS" },
  { no: 10, name: "CARE_CAMPAIGNS" },
  { no: 11, name: "SELF_SCHEDULES" },
  { no: 12, name: "REPORTS" },
  { no: 13, name: "GPT_STORE" },
]);

/**
 * @generated from message qliq_protobuf.sidebar.SidebarData.SidebarItem
 */
export class SidebarData_SidebarItem extends Message<SidebarData_SidebarItem> {
  /**
   * @generated from field: qliq_protobuf.sidebar.SidebarData.Module module = 1;
   */
  module = SidebarData_Module.UNKNOWN;

  /**
   * @generated from field: string url = 2;
   */
  url = "";

  constructor(data?: PartialMessage<SidebarData_SidebarItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.sidebar.SidebarData.SidebarItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "module", kind: "enum", T: proto3.getEnumType(SidebarData_Module) },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SidebarData_SidebarItem {
    return new SidebarData_SidebarItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SidebarData_SidebarItem {
    return new SidebarData_SidebarItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SidebarData_SidebarItem {
    return new SidebarData_SidebarItem().fromJsonString(jsonString, options);
  }

  static equals(a: SidebarData_SidebarItem | PlainMessage<SidebarData_SidebarItem> | undefined, b: SidebarData_SidebarItem | PlainMessage<SidebarData_SidebarItem> | undefined): boolean {
    return proto3.util.equals(SidebarData_SidebarItem, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.sidebar.SidebarData.BrandingSettings
 */
export class SidebarData_BrandingSettings extends Message<SidebarData_BrandingSettings> {
  /**
   * @generated from field: string primary_color = 1;
   */
  primaryColor = "";

  /**
   * @generated from field: string secondary_color = 2;
   */
  secondaryColor = "";

  constructor(data?: PartialMessage<SidebarData_BrandingSettings>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.sidebar.SidebarData.BrandingSettings";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "primary_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "secondary_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SidebarData_BrandingSettings {
    return new SidebarData_BrandingSettings().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SidebarData_BrandingSettings {
    return new SidebarData_BrandingSettings().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SidebarData_BrandingSettings {
    return new SidebarData_BrandingSettings().fromJsonString(jsonString, options);
  }

  static equals(a: SidebarData_BrandingSettings | PlainMessage<SidebarData_BrandingSettings> | undefined, b: SidebarData_BrandingSettings | PlainMessage<SidebarData_BrandingSettings> | undefined): boolean {
    return proto3.util.equals(SidebarData_BrandingSettings, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.sidebar.SidebarData.User
 */
export class SidebarData_User extends Message<SidebarData_User> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName = "";

  /**
   * @generated from field: string middle_name = 3;
   */
  middleName = "";

  /**
   * @generated from field: string last_name = 4;
   */
  lastName = "";

  /**
   * @generated from field: string avatar_url = 5;
   */
  avatarUrl = "";

  constructor(data?: PartialMessage<SidebarData_User>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.sidebar.SidebarData.User";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "middle_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SidebarData_User {
    return new SidebarData_User().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SidebarData_User {
    return new SidebarData_User().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SidebarData_User {
    return new SidebarData_User().fromJsonString(jsonString, options);
  }

  static equals(a: SidebarData_User | PlainMessage<SidebarData_User> | undefined, b: SidebarData_User | PlainMessage<SidebarData_User> | undefined): boolean {
    return proto3.util.equals(SidebarData_User, a, b);
  }
}

